<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-ISSUER' : 'EDIT-ISSUER') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <!--name-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'ISSUER-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
            <!--clientId-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'CLIENT-ID' | translate}} *
                    </span>
                    <input id="clientId" kendoTextBox formControlName="clientId" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="clientId.hasError('required') && clientId.touched">
                        {{'REQUIRED-CLIENT-ID' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--description-->
        <div class="row">
            <div class="col-12">
                <label for="description" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DESCRIPTION' | translate }}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="2"
                        formControlName="description" maxlength="1000" style="max-height: 300px;">
                    </textarea>
                </label>
            </div>
        </div>
        <div class="row">
            <!--issuerUri-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'ISSUER-URI' | translate}} *
                    </span>
                    <input id="issuerUri" kendoTextBox formControlName="issuerUri" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="issuerUri.hasError('required') && issuerUri.touched">
                        {{'REQUIRED-ISSUER-URI' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!isValidUri(issuerUri) && issuerUri.hasError('pattern') && issuerUri.touched">
                        {{'INVALID-URL' | translate}}
                    </div>
                </label>
            </div>
            <!--authorizeUri-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'AUTHORIZE-URI' | translate}} *
                    </span>
                    <input id="authorizeUri" kendoTextBox formControlName="authorizeUri" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="authorizeUri.hasError('required') && authorizeUri.touched">
                        {{'REQUIRED-AUTHORIZE-URI' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!isValidUri(authorizeUri) && authorizeUri.hasError('pattern') && authorizeUri.touched">
                        {{'INVALID-URL' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <!--tokenUri-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'TOKEN-URI' | translate}} *
                    </span>
                    <input id="tokenUri" kendoTextBox formControlName="tokenUri" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="tokenUri.hasError('required') && tokenUri.touched">
                        {{'REQUIRED-TOKEN-URI' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!isValidUri(tokenUri) && tokenUri.hasError('pattern') && tokenUri.touched">
                        {{'INVALID-URL' | translate}}
                    </div>
                </label>
            </div>
            <!--openIdUri-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'OPEN-ID-URI' | translate}}
                    </span>
                    <input id="openIdUri" kendoTextBox formControlName="openIdUri" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!isValidUri(openIdUri) && openIdUri.hasError('pattern') && openIdUri.touched">
                        {{'INVALID-URL' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--secret-->
        <div class="row" *ngIf="false">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'SECRET' | translate}}
                    </span>
                    <input id="secret" kendoTextBox formControlName="secret" maxlength="255" />
                </label>
            </div>
        </div>
        <label class="k-text-uppercase dark mr-2 pt-2 w-100" for="enabled">{{ 'ENABLED' | translate }}</label>
        <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
        </kendo-switch>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>